<template>
  <div class="bind-main">
    <div class="bind-main-head">
      <img @click="clickHandler('/h5/login')" data-track-text="返回登录" aria-label="返回登录" style="margin-left: 28px" src="../assets/H5/go-back.png" alt=""/>
      <div>绑定手机</div>
    </div>
    <div class="bind-main-content">
      <div class="bind-main-img">
        <img src="../assets/anquan.png" alt="" width="38px" height="49px">
      </div>
      <div class="bind-main-tip">
        为了您的安全，请绑定手机号，绑定后可使用该手机号快捷登录
      </div>
      <div class="bind-main-input">
        <el-form :label-position="'right'" :model="formLabelAlign" :rules="phone_login_rules" ref="phoneLoginRef">
          <el-form-item prop="phone">
                    <span style="display: flex;
                    align-items: center;
                    justify-content: center;font-size: 27px;
                    position: absolute;
                    float: left;
                    border: 1px solid #dcdfe6;
                    background: white;
                    padding: 0 10px;
                        height: 68px;
                    width: 115px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #333333;
                    border-radius: 4px;" class="bind-phone-prefix">+86</span>
            <el-input v-model="formLabelAlign.phone" style="margin-left: 136px;width: 590px;"
                      placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="validate">
            <el-input v-model="formLabelAlign.validate" style="width: 512px;"
                      placeholder="请输入4位验证码"></el-input>
            <span>
                        <img class="bind-captcha" style="float: right;height: 70px;border-radius: 4px;cursor: pointer" :src="qrcodeUrl"
                             alt="验证码加载失败..."
                             data-track-text="刷新验证码"
                             aria-label="刷新验证码"
                             @click="getValicode"/>
                    </span>
          </el-form-item>
          <el-form-item class="bind-phone-code-item" prop="phoneValidate" style="width: 512px;">
            <el-input v-model="formLabelAlign.phoneValidate" placeholder="请输入6位验证码"></el-input>
            <span v-show="Verification" style="    font-size: 24px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: rgb(28, 80, 167);
                    position: absolute;
                    width: 210px;
                    background: white;
                    border: 1px solid #dcdfe6;
                    height: 68px;
                    border-radius: 4px;
                    cursor: pointer;
                    text-align: center;
                        line-height: 65px;
                    " class="bind-phone-code-button" data-track-text="H5绑定手机获取验证码" aria-label="H5绑定手机获取验证码" @click="handleTimeClick">
                        获取手机验证码
                    </span>
            <span v-show="!Verification" style="    font-size: 24px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: rgb(28, 80, 167);
                    position: absolute;
                    width: 210px;
                    background: white;
                    border: 1px solid #dcdfe6;
                    height: 68px;
                    border-radius: 4px;
                    cursor: pointer;
                    text-align: center;
                        line-height: 65px;
                    " class="bind-phone-code-button">
                        {{ timers }}秒后重新获取
                    </span>
          </el-form-item>
          <el-form-item prop="checked">
            <el-checkbox class="mycheckbox" style="
                float: left;
                font-size: 14px;
                font-family: NotoSansHans;
                font-weight: 400;
                color: #666666;" v-model="formLabelAlign.checked">
              我已阅读并同意遵守
            </el-checkbox>
            <span style="float: left;
                font-size: 24px;
                font-family: NotoSansHans;
                font-weight: 400;
                color: #1c50a7;cursor: pointer" data-track-text="H5绑定手机查看用户服务协议" aria-label="H5绑定手机查看用户服务协议" @click="openAgreement">《用户服务协议》</span>
          </el-form-item>
          <el-form-item v-if="errorTitle!==''">
            <div style="width: 100%;color: red;font-size: 24px">{{ errorTitle }}</div>
          </el-form-item>
          <el-form-item>
            <div class="bind-submit" data-track-text="H5提交绑定手机" aria-label="H5提交绑定手机" @click="submitPhoneBindFrom" style="width: 706px;
height: 80px;
background: #184482;
border-radius: 3px;display: flex;
    align-items: center;
    justify-content: center;">
                <span style="
font-size: 24px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #FFFFFF;">
                        绑定手机
                </span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  authServiceClient,
  checkPhoneRequest,
  phoneBindRequest,
  phoneCodeRequest,
  valicodeRequest
} from "@/tools/api/auth-api";

export default {
  name: "NewBind",
  data() {
    return {
      timers: 60,
      Verification: true,
      errorTitle: "",
      isBind: false,
      formLabelAlign: {
        phone: "",
        validate: "",
        phoneValidate: "",
        checked: true
      },
      phone_login_rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号", trigger: "blur"},
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ],
        phoneValidate: [
          {validator: this.validatePhoneCode, trigger: 'blur'}
        ],
        checked: [
          {validator: this.validateChecked, trigger: 'change'}
        ]
      },
      qrcodeUrl: undefined
    }
  },
  created() {
    this.getValicode()
  },
  methods: {
    clickHandler(url) {
      this.$router.push(url)
    },
    openAgreement() {
      window.open("/agree");
    },
    submitPhoneBindFrom() {
      this.isBind = true;
      const openid = this.$route.params.openid;
      const type = this.$route.params.type;
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        let request = phoneBindRequest;
        request.setPhone(this.formLabelAlign.phone);
        request.setPhoneCode(this.formLabelAlign.phoneValidate);
        request.setOpenid(openid)
        request.setType(type)
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.phoneBind(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            this.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            this.$router.push("/index")
            window.location.reload()
            return;
          }
          if (res.getStatus() === 4) {
            this.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: "绑定成功"
            });
            window.open("https://user.wesitrans.com/account", "_self");
            return;
          }
          this.errorTitle = res.getMessage();
          this.getValicode();
          this.isLogin = false;
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/h5/login")
          }
          this.isLogin = false;
        })
      });
      this.isBind = false;
    },
    validateChecked(rule, value, callback) {
      if (!value) {
        callback(new Error('请阅读并同意协议'))
        return
      }
      callback()
    },
    handleTimeClick() {
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const that = this;
        let request = phoneCodeRequest;
        request.setCode(this.formLabelAlign.validate)
        request.setPhone(this.formLabelAlign.phone)
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
            .then(res => {
              if (res.getStatus()) {
                that.messages = "";
                that.Verification = false;
                this.auth_timer = setInterval(() => {
                  that.timers--;
                  if (that.timers <= 0) {
                    that.Verification = true;
                    that.timers = 60;
                    clearInterval(that.auth_timer)
                  }
                }, 1000)
                return;
              }
              that.getValicode();
              that.messages = "验证码错误"
              that.Verification = true;
              that.timers = 60;
            }).catch(err => {
          that.getValicode();
          that.messages = "手机验证码发送失败"
          that.Verification = true;
          that.timers = 60;
        });
      });
    },
    validatePhone(rule, value, callback) {
      let request = checkPhoneRequest;
      request.setPhone(value);
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('手机号有误'))
          return;
        }
        if (res.getStatus() === 3) {
          this.errorTitle = '手机号未注册，您确定绑定当前手机号吗？'
          callback()
          return;
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return;
        }
        this.errorTitle = '手机号已注册，您确定绑定到当前用户吗？'
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    validatePhoneCode(rule, value, callback) {
      if (!this.isBind) {
        callback()
        return
      }
      if (value === null || value === undefined || value === "") {
        callback(new Error('请输入手机验证码'))
        return;
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return;
      }
      callback()
    },
    getValicode() {
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
      })
    },
  }
}
</script>

<style lang="less" scoped>
.bind-main {
  min-width: 768px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-flow: column;
  align-items: center;

  .bind-main-head {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;

    div {
      flex: 1;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      text-align: center;
      margin-right: 60px;
    }
  }

  .bind-main-content {
    margin-top: 65px;
    width: 768px;
    height: 1051px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    flex-flow: column;

    .bind-main-img {
      margin-bottom: 15px;
    }

    .bind-main-tip {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      margin-bottom: 65px;
    }

    .bind-main-input {
      /deep/ .el-form-item__error {
        color: #F56C6C;
        font-size: 24px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
      }

      /deep/ .el-form-item {
        margin-bottom: 44px;
      }

      /deep/ .el-input__inner {
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 24px;
        height: 70px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
      }

      /deep/ .el-checkbox__inner {
        width: 37px;
        height: 37px;
        border-radius: 6px;
      }

      /deep/ .el-checkbox:last-of-type {
        display: flex;
        align-items: center;
      }

      /deep/ .el-checkbox__label {
        height: 24px;
        font-size: 24px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #666666;
      }

      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: rgba(221, 221, 221, 1);
        border-color: rgba(221, 221, 221, 1);
        width: 37px;
        height: 37px;
        border-radius: 6px;
      }

      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
        transform: rotate(130deg) scaleY(-2);
      }

      /deep/ .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 1px solid rgba(28, 80, 167, 1);
        border-left: 0;
        border-top: 0;
        height: 7px;
        left: 8px;
        position: absolute;
        top: 8px;
        width: 18px;
        transform-origin: center;
      }
    }
  }
}

@media (max-width: 768px) {
  .bind-main {
    width: 100%;
    min-width: 0;
    min-height: 100vh;
    overflow-x: hidden;
  }

  .bind-main-head {
    height: 56px !important;
  }

  .bind-main-head > img {
    width: 28px;
    height: 28px;
    margin-left: 12px !important;
    object-fit: contain;
  }

  .bind-main-head > div {
    margin-right: 40px !important;
    font-size: 17px !important;
  }

  .bind-main-content {
    width: 100% !important;
    height: auto !important;
    margin-top: 0 !important;
    padding: 30px 16px calc(84px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .bind-main-tip {
    margin-bottom: 28px !important;
    text-align: center;
    font-size: 14px !important;
    line-height: 22px;
  }

  .bind-main-input,
  .bind-main-input /deep/ .el-form,
  .bind-main-input /deep/ .el-form-item {
    width: 100% !important;
    box-sizing: border-box;
  }

  .bind-main-input /deep/ .el-form-item {
    margin-bottom: 26px !important;
  }

  .bind-main-input /deep/ .el-input {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .bind-main-input /deep/ .el-input__inner {
    height: 46px !important;
    font-size: 14px !important;
  }

  .bind-main-input /deep/ .el-form-item:first-child .el-input {
    width: calc(100% - 72px) !important;
    margin-left: 72px !important;
  }

  .bind-phone-prefix {
    width: 70px !important;
    height: 44px !important;
    padding: 0 !important;
    font-size: 14px !important;
    line-height: 44px;
    text-align: center;
    box-sizing: border-box;
  }

  .bind-main-input /deep/ .el-form-item:nth-child(2) .el-input {
    width: calc(100% - 112px) !important;
  }

  .bind-captcha {
    width: 104px;
    height: 46px !important;
    object-fit: cover;
  }

  .bind-phone-code-item /deep/ .el-input {
    width: calc(100% - 124px) !important;
  }

  .bind-phone-code-button {
    right: 0;
    width: 120px !important;
    height: 44px !important;
    font-size: 12px !important;
    line-height: 44px !important;
  }

  .bind-main-input /deep/ .el-checkbox__inner {
    width: 18px !important;
    height: 18px !important;
    border-radius: 4px !important;
  }

  .bind-main-input /deep/ .el-checkbox__label,
  .bind-main-input /deep/ .el-form-item:nth-child(4) span {
    font-size: 13px !important;
  }

  .bind-submit {
    width: 100% !important;
    height: 46px !important;
  }

  .bind-submit > span {
    font-size: 16px !important;
  }
}
</style>
